/** UI copy — FR / ES, locale picked from the URL slug (/fr, /es). */

export type Locale = "fr" | "es";

const fr = {
  agent_name: "NORA",
  brand_chip: "ElevenLabs · banc d'essai",
  start: "Appeler NORA",
  stop: "Raccrocher",
  status_offline: "Hors ligne",
  status_connecting: "Connexion…",
  status_listening: "En ligne · vous écoute",
  status_speaking: "En ligne · en train de parler",
  status_ended: "Appel terminé",
  status_error: "Erreur — voir la console",
  hint_idle: "Micro requis · la conversation démarre dès la connexion",
  hint_live: "Parlez naturellement — vous pouvez couper la parole à l'assistante",
  speaker_user: "Vous",
  voice_label: "Voix",
  features: "Fonctionnalités",
  features_title: "Ce que NORA sait faire",
  transcript: "Transcript",
  catalog_title: "Catalogue de démo — produits recherchables",
  page_title: "NEXUM — Assistante vocale",
  tool_search: "Recherche produit",
  tool_hours: "Vérification des horaires",
  tool_nearby: "Recherche des pharmacies proches",
  tool_service: "Infos service",
  tool_product_nearby: "près de vous",
  tool_reserve: "Réservation",
  tool_delivery: "Commande en livraison",
  tool_orders: "Commandes du compte",
  tool_cancel: "Annulation commande",
  tool_advice: "Conseils notice",
  tool_appointment: "RDV",
  tool_message: "Message au pharmacien",
  tool_whatsapp: "Envoi du lien WhatsApp",
  setup_title: "Qui êtes-vous ?",
  setup_subtitle: "Choisissez votre profil — NORA vous reconnaîtra à chaque appel.",
  setup_first_name: "Prénom",
  setup_last_name: "Nom",
  setup_phone: "Téléphone mobile",
  setup_locale: "Langue par défaut",
  setup_submit: "Commencer",
} as const;

const es: { [K in keyof typeof fr]: string } = {
  agent_name: "NORA",
  brand_chip: "ElevenLabs · banco de pruebas",
  start: "Llamar a NORA",
  stop: "Colgar",
  status_offline: "Desconectada",
  status_connecting: "Conectando…",
  status_listening: "En línea · le escucha",
  status_speaking: "En línea · hablando",
  status_ended: "Llamada finalizada",
  status_error: "Error — ver la consola",
  hint_idle: "Micrófono necesario · la conversación empieza al conectar",
  hint_live: "Hable con naturalidad — puede interrumpir a la asistente",
  speaker_user: "Usted",
  voice_label: "Voz",
  features: "Funcionalidades",
  features_title: "Lo que NORA sabe hacer",
  transcript: "Transcripción",
  catalog_title: "Catálogo de demo — productos disponibles",
  page_title: "NEXUM — Asistente de voz",
  tool_search: "Búsqueda de producto",
  tool_hours: "Comprobando horarios",
  tool_nearby: "Buscando farmacias cercanas",
  tool_service: "Información del servicio",
  tool_product_nearby: "cerca de usted",
  tool_reserve: "Reserva",
  tool_delivery: "Pedido a domicilio",
  tool_orders: "Pedidos de la cuenta",
  tool_cancel: "Anulación de pedido",
  tool_advice: "Consejos del prospecto",
  tool_appointment: "Cita",
  tool_message: "Mensaje al farmacéutico",
  tool_whatsapp: "Enviando enlace de WhatsApp",
  setup_title: "¿Quién es usted?",
  setup_subtitle: "Elija su perfil — NORA le reconocerá en cada llamada.",
  setup_first_name: "Nombre",
  setup_last_name: "Apellido",
  setup_phone: "Teléfono móvil",
  setup_locale: "Idioma por defecto",
  setup_submit: "Empezar",
} as const;

export type StringKey = keyof typeof fr;

export const getLocale = (): Locale =>
  window.location.pathname.replace(/\/+$/, "").endsWith("/es") ? "es" : "fr";

export const strings = getLocale() === "es" ? es : fr;
